/* Serajeldin quick-add: template-agnostic variant picker.
   Replaces Dawn's quick-add (which required section[id^="MainProduct-"] +
   variant-radios from the stock product template — absent on our custom
   premium product pages, so the modal silently failed). */
if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartEl && typeof cartEl.setActiveElement === 'function') cartEl.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';
      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      const spinner = opener.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const productUrl = (opener.getAttribute('data-product-url') || '').split('?')[0];
      fetch(productUrl + '.js')
        .then((r) => { if (!r.ok) throw new Error('product fetch failed'); return r.json(); })
        .then((product) => {
          this.renderProduct(product, productUrl);
          super.show(opener);
        })
        .catch(() => { window.location.href = productUrl; })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    money(cents) {
      return Math.round(cents / 100).toLocaleString('ar-EG') + ' ج.م';
    }

    renderProduct(product, productUrl) {
      const self = this;
      let selected = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      const img = (product.featured_image || (product.images && product.images[0]) || '');

      let html = '';
      html += '<style>' +
        '.sj-qa{direction:rtl;font-family:\'Almarai\',sans-serif;color:#2b1a12;width:100%;}' +
        '.sj-qa__head{display:flex;gap:14px;align-items:center;margin-bottom:16px;}' +
        '.sj-qa__img{width:84px;height:84px;object-fit:cover;border-radius:14px;border:1px solid rgba(201,138,75,.3);background:#fffdfa;flex:0 0 auto;}' +
        '.sj-qa__title{font-family:\'Cairo\',sans-serif;font-weight:800;font-size:17px;line-height:1.4;margin:0;}' +
        '.sj-qa__title a{color:#2b1a12;text-decoration:none;}' +
        '.sj-qa__price{margin-top:4px;font-family:\'Cairo\',sans-serif;font-weight:800;color:#65170b;font-size:16px;}' +
        '.sj-qa__was{color:#9b8672;text-decoration:line-through;font-size:13px;font-weight:700;margin-inline-start:8px;}' +
        '.sj-qa__label{font-weight:800;font-size:14px;margin:0 0 8px;}' +
        '.sj-qa__opts{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:18px;}' +
        '.sj-qa__opt{cursor:pointer;border:1.5px solid rgba(201,138,75,.45);background:#fffdfa;color:#2b1a12;border-radius:999px;padding:9px 16px;font-family:\'Almarai\',sans-serif;font-weight:700;font-size:14px;transition:all .15s ease;}' +
        '.sj-qa__opt[aria-pressed="true"]{background:#2b1a12;border-color:#2b1a12;color:#f6efe7;}' +
        '.sj-qa__opt[disabled]{opacity:.4;cursor:not-allowed;text-decoration:line-through;}' +
        '.sj-qa__add{display:block;width:100%;cursor:pointer;background:#65170b;color:#fff;border:0;border-radius:999px;padding:14px 18px;font-family:\'Cairo\',sans-serif;font-size:16px;font-weight:800;transition:background .15s ease;}' +
        '.sj-qa__add:hover{background:#7d2010;}' +
        '.sj-qa__add[disabled]{opacity:.6;cursor:wait;}' +
        '.sj-qa__link{display:block;text-align:center;margin-top:10px;font-size:13px;color:#8a6f52;}' +
        '</style>';
      html += '<div class="sj-qa">';
      html += '<div class="sj-qa__head">';
      if (img) html += '<img class="sj-qa__img" src="' + img + '" alt="">';
      html += '<div><h3 class="sj-qa__title"><a href="' + productUrl + '">' + product.title + '</a></h3>';
      html += '<div class="sj-qa__price" data-sj-qa-price></div></div></div>';
      if (product.variants.length > 1) {
        html += '<p class="sj-qa__label">اختار اللي يناسبك:</p><div class="sj-qa__opts">';
        product.variants.forEach(function (v) {
          html += '<button type="button" class="sj-qa__opt" data-sj-qa-variant="' + v.id + '"' +
            (v.available ? '' : ' disabled') +
            ' aria-pressed="' + (v.id === selected.id ? 'true' : 'false') + '">' + v.title + '</button>';
        });
        html += '</div>';
      }
      html += '<button type="button" class="sj-qa__add" data-sj-qa-add>أضف للسلة</button>';
      html += '<a class="sj-qa__link" href="' + productUrl + '">شوف كل تفاصيل المنتج ←</a>';
      html += '</div>';
      this.modalContent.innerHTML = html;

      const priceEl = this.modalContent.querySelector('[data-sj-qa-price]');
      function paintPrice() {
        let p = '<span>' + self.money(selected.price) + '</span>';
        if (selected.compare_at_price && selected.compare_at_price > selected.price) {
          p += '<span class="sj-qa__was">' + self.money(selected.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = p;
      }
      paintPrice();

      this.modalContent.querySelectorAll('[data-sj-qa-variant]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const v = product.variants.find(function (x) { return String(x.id) === btn.getAttribute('data-sj-qa-variant'); });
          if (!v || !v.available) return;
          selected = v;
          self.modalContent.querySelectorAll('[data-sj-qa-variant]').forEach(function (b) {
            b.setAttribute('aria-pressed', String(b === btn));
          });
          paintPrice();
        });
      });

      const addBtn = this.modalContent.querySelector('[data-sj-qa-add]');
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        addBtn.disabled = true;
        const original = addBtn.textContent;
        addBtn.textContent = '...';
        fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js'.replace('.js.js', '.js') && '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: selected.id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status && data.status !== 200) throw new Error(data.description || 'add failed');
            if (data.sections && data.sections['cart-drawer']) {
              const doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
              const newInner = doc.querySelector('.drawer__inner');
              const curInner = document.querySelector('#CartDrawer .drawer__inner');
              if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
            }
            if (data.sections && data.sections['cart-icon-bubble']) {
              const bubble = document.getElementById('cart-icon-bubble');
              if (bubble) {
                const doc2 = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
                const inner2 = doc2.querySelector('.shopify-section');
                bubble.innerHTML = inner2 ? inner2.innerHTML : data.sections['cart-icon-bubble'];
              }
            }
            const drawerEl = document.querySelector('cart-drawer');
            self.hide(true);
            if (drawerEl) {
              drawerEl.classList.remove('is-empty');
              if (typeof drawerEl.open === 'function') drawerEl.open();
            }
            document.dispatchEvent(new CustomEvent('eg:cart:updated'));
          })
          .catch(function (err) {
            console.error('[sj-quick-add]', err);
            addBtn.disabled = false;
            addBtn.textContent = original;
            window.location.href = productUrl;
          });
      });
    }
  });
}
